module.exports = __webpack_public_path__ + "static/media/02.75acc1b2.jpg";